<p-card>
  <div class="header">{{title}}</div>
  <p-gmap [options]="options" [overlays]="overlays" [style]="{'width':mapWidth,'height':mapHeight}" (onMapReady)="setMap($event)"></p-gmap>
  <ng-template pTemplate="footer">
    See all your <a [routerLink]="['/devices']">Devices</a>
    {{footer}}
  </ng-template>
</p-card>
